import React from 'react';
import { Info } from 'lucide-react';

export default function TermMismatchModal({ isOpen, onClose, error }) {
  if (!isOpen || !error) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white w-[95%] md:w-[400px] rounded-lg shadow-lg p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-black"
        >
          ✕
        </button>

        <div className="flex items-center gap-2 mb-4">
          <Info size={20} className="text-red-500 shrink-0" />
          <h2 className="font-duplet text-lg font-semibold">
            {error.type === 'FREQUENCY_MISMATCH'
              ? 'Payment frequency mismatch'
              : 'Installment term mismatch'}
          </h2>
        </div>

        <p className="text-sm text-gray-700 mb-4">{error.details}</p>

        {error.suggestion && (
          <div className="bg-[#FFF8CF] rounded-md p-3 mb-4">
            <p className="text-sm font-medium">{error.suggestion}</p>
          </div>
        )}

        <button
          onClick={onClose}
          className="w-full bg-[#FFDE11] text-black font-medium py-2 rounded hover:bg-yellow-300"
        >
          Got it
        </button>
      </div>
    </div>
  );
}
